(function () {
  function initSlider(root) {
    if (root.dataset.ngSliderInitialized === 'true') return;
    root.dataset.ngSliderInitialized = 'true';

    var track = root.querySelector('[data-ng-track]');
    var prev = root.querySelector('[data-ng-prev]');
    var next = root.querySelector('[data-ng-next]');
    var bar = root.querySelector('[data-ng-progress]');

    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.ng-card');
      return card ? card.getBoundingClientRect().width + 16 : 360;
    }

    function update() {
      if (!bar) return;

      var max = track.scrollWidth - track.clientWidth;
      var percentage = max > 0
        ? Math.max(15, ((track.scrollLeft + track.clientWidth) / track.scrollWidth) * 100)
        : 100;

      bar.style.width = percentage + '%';
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({
          left: -cardStep(),
          behavior: 'smooth'
        });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({
          left: cardStep(),
          behavior: 'smooth'
        });
      });
    }

    track.addEventListener('scroll', update, { passive: true });

    var pointerDown = false;
    var dragging = false;
    var startX = 0;
    var startLeft = 0;
    var activePointerId = null;
    var dragThreshold = 6;

    track.addEventListener('pointerdown', function (event) {
      /*
       * Alleen de primaire muisknop gebruiken.
       * Touch- en peninvoer blijven eveneens ondersteund.
       */
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      pointerDown = true;
      dragging = false;
      startX = event.clientX;
      startLeft = track.scrollLeft;
      activePointerId = event.pointerId;
    });

    track.addEventListener('pointermove', function (event) {
      if (!pointerDown || event.pointerId !== activePointerId) return;

      var distance = event.clientX - startX;

      /*
       * Activeer drag pas wanneer de gebruiker daadwerkelijk beweegt.
       * Daardoor blijft een normale klik op een product- of collectielink werken.
       */
      if (!dragging && Math.abs(distance) > dragThreshold) {
        dragging = true;
        track.classList.add('is-grabbing');

        try {
          track.setPointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture is niet essentieel; doorgaan zonder capture.
        }
      }

      if (!dragging) return;

      event.preventDefault();
      track.scrollLeft = startLeft - distance;
    });

    function endPointer(event) {
      if (!pointerDown) return;
      if (
        typeof event.pointerId !== 'undefined' &&
        activePointerId !== null &&
        event.pointerId !== activePointerId
      ) {
        return;
      }

      pointerDown = false;
      track.classList.remove('is-grabbing');

      if (
        activePointerId !== null &&
        track.hasPointerCapture &&
        track.hasPointerCapture(activePointerId)
      ) {
        try {
          track.releasePointerCapture(activePointerId);
        } catch (error) {
          // Capture kan al automatisch vrijgegeven zijn.
        }
      }

      /*
       * Voorkom alleen de eerstvolgende klik wanneer er werkelijk is gesleept.
       * Bij een gewone pointerdown/pointerup wordt de link normaal geopend.
       */
      if (dragging) {
        var preventDraggedClick = function (clickEvent) {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
          track.removeEventListener('click', preventDraggedClick, true);
        };

        track.addEventListener('click', preventDraggedClick, true);
      }

      dragging = false;
      activePointerId = null;
    }

    track.addEventListener('pointerup', endPointer);
    track.addEventListener('pointercancel', endPointer);
    track.addEventListener('lostpointercapture', function () {
      pointerDown = false;
      dragging = false;
      activePointerId = null;
      track.classList.remove('is-grabbing');
    });

    update();
  }

  function initReveal(scope) {
    var context = scope || document;
    var elements = context.querySelectorAll('.ng-reveal:not([data-ng-reveal-initialized])');

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.dataset.ngRevealInitialized = 'true';
        element.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12
    });

    elements.forEach(function (element) {
      element.dataset.ngRevealInitialized = 'true';
      observer.observe(element);
    });
  }

  function init(scope) {
    var context = scope || document;

    context.querySelectorAll('[data-ng-slider]').forEach(initSlider);
    initReveal(context);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
